import { render, staticRenderFns } from "./ThemeToggle.vue?vue&type=template&id=32021a2f&scoped=true&"
import script from "./ThemeToggle.vue?vue&type=script&lang=ts&"
export * from "./ThemeToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32021a2f",
  null
  
)

export default component.exports